import { TOGGLE_MODAL, SET_DESIRED_PATH, SET_MODAL_MESSAGE } from '../actionTypes'

export const toggleModal = (modalOpen, path = false, message = null) => {
  return dispatch => {
    dispatch({
      type: TOGGLE_MODAL,
      modalOpen
    })

    dispatch({
      type: SET_MODAL_MESSAGE,
      message
    })

    if (path) {
      dispatch({
        type: SET_DESIRED_PATH,
        path
      })
    }
  }
}
